module.exports = __webpack_public_path__ + "static/eolian-desk-36884e26eb7f5cbe78a973270df3f271.svg";